import defineReactive from './DefineReactive';
import Dep from './Dep';
import supported from './isSupoortObjectDefineProperty';
import observe from './observe';
import { arrayMethods } from './array';

const hasProto = '__proto__' in {};

const arrayKeys = Object.getOwnPropertyNames(arrayMethods);

function def(obj, key,val, emuerable) {
    if (supported) {
        Object.defineProperty(obj, key, {
            value: val,
            emuerable: !!emuerable,
            writable: true,
            configurable: true
        })
    } else {
        if (obj && obj[key]) {
            obj[key] = val;
        }
    }
}

function protoAugment (target, src, keys) {
    target.__proto__ = src;
}

function copyAugment (target, src, keys) {
    for (let i = 0, l = keys.length; i < l; i++) {
        const key = keys[i];
        def(target, key, src[key]);
    }
}
export default class Observer {
    constructor (value) {
        this.value = value;
        this.dep = new Dep();
        def(value, '__ob__', this);
        
        if (!Array.isArray(value)) {
            this.walk(value);
        } else {
            const augment = hasProto ? protoAugment : copyAugment;
            augment(value, arrayMethods, arrayKeys);
            this.observeArray(value);
        }
    }

    walk (obj) {
        const keys = Object.keys(obj);
        for(let i=0; i < keys.length; i++) {
            defineReactive(obj, keys[i], obj[keys[i]]); 
        }
    }

    observeArray (items) {
        for(let i = 0, l = items.length; i < l;i++) {
            observe(items[i]);
        }
    }
}